import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import apiUrl from '../../Apiurl';
import stilePulsanti from '../../interfaccia/stilePulsanti';

function CSVuploadTrackingBRT({setPopUpWindow}) {

  
    const [selectedFile, setSelectedFile] = useState();
    const [isFilePicked, setIsFilePicked] = useState(false);
    const [risultatoOperazione, setRisultatoOperazione] = useState("In attesa dell'upload");
    const [risultatoPatch, setRisultatoPatch] = useState(false);
    const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState("");

    const {
      tastoChiudiAspetto
  } = stilePulsanti

  useEffect(() => {
    const getUserMetadata = async () => {
        try {
            const accessToken = await getAccessTokenSilently();
            setToken(accessToken);
        } catch (e) {
            console.log(e.message);
        }
    };
    getUserMetadata();
}, [getAccessTokenSilently, user?.sub]);


    const changeHandler = (event) => {
      setSelectedFile(event.target.files[0]);
      setIsFilePicked(true);
    };

    const handleSubmission = () => {
      if (!token) {
        console.warn("sto aspettando un token")
        return;
    }
      const formData = new FormData();
      formData.append('uploaded_file', selectedFile);
      const config = {
        headers: {
            'Authorization': 'Bearer ' + token,
          },
      }
      axios.post(apiUrl + "/logistica/csv/importTrackingBRT", formData, config)
                .then((resp) => {
                    if (resp.data.errno) {
                      setRisultatoPatch(resp.data)
                    } else {
                      setRisultatoPatch(resp.data);
                    }
                })
    };


  return (
    
      <div className='flex pa3 shadow-5 br4'>
        {setPopUpWindow && <button className="dim tastoInputOrizzontale br3" onClick={(e) => {e.preventDefault();setPopUpWindow(false);}}>{tastoChiudiAspetto}</button>}
      <div className="w-50 pa3">
        
        <h1>Tracking BRT</h1>
        <p>Importa i risultati ottenuti dal file mandato da BRT</p>
        <p>NON SERVE CANCELLARE LE COLONNE</p>
        <input type="file" accept="csv" name="file" onChange={changeHandler} />
        {isFilePicked ? (
          <div>
            <p>Nome del file: {selectedFile.name}</p>
            <p>Tipo file: {selectedFile.type}</p>
            <p>Dimensione in bytes: {selectedFile.size}</p>
            <p>
              Data ultima modifica:{' '}
              {selectedFile.lastModifiedDate.toLocaleDateString()}
            </p>
          </div>
        ) : (
          <p>Seleziona un file</p>
        )}
        <div>
          <button onClick={handleSubmission} className="f6 link dim ba b--dark-green ph3 pv2 mt4 dib white bg-dark-green br3 mr2 w-70 center">Carica</button>
        </div>
        <p>{risultatoOperazione}</p>
      </div>
      <div className='w-50 ml2 pa3 bl bordoColAlt'>
      {risultatoPatch && <pre className='pa3 max70 sezioneConScroll'>{JSON.stringify(risultatoPatch, null, 2)}</pre>}
      </div>
      </div>
  )

}





export default CSVuploadTrackingBRT;